import react, {useEffect, useState} from 'react'

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'

import CoverArt from '../../assets/img/albumart/makemeproudamerica.png'

import { connect } from 'react-redux'

import Header from '../Landing/Header'
import Footer from '../Landing/Footer'
import Container from 'react-bootstrap/Container'



const PressReleaseMakeMeProud = ({match:{params}}) => {
    
    return <>
    <Header />
        <Container style={{backgroundColor:'lightgray',color:'black'}}>
            <Row>
                <Col>
                    <p style={{paddingTop:'20px'}}>For Release: April 2, 2026</p>
                    <hr></hr>
                    <h1 className="h1" style={{textTransform:'uppercase'}}>John Levengood Unveils “Make Me Proud, America,” a New Anthem Calling the Nation to Wake Up</h1>
                    <p style={{textAlign:'center'}}><Image src={CoverArt} width="400"></Image></p>
                    <p>Recording artist, John Levengood (he/him/his), releases new song, “Make Me Proud, America”, in protest of the brutality inflicted by ICE agents in communities around the country. He is excited to share this message on festival stages around the country this summer. The song can be streamed on all streaming platforms worldwide including Spotify, Apple Music, Pandora, and Tidal starting April 2, 2026. This marks John’s 17th studio release. Listen to the song here: <a href="https://artists.landr.com/991043228981" noreferrer target="_blank">https://artists.landr.com/991043228981</a> </p>
                    <p>John's Statement on the New Song:</p>
                    <blockquote style={{paddingLeft:'30px'}}>
                        <p>“Patriotism is earned, not unconditional. I want to love my country but cannot. A country where ICE agents kill protesters without consequence and the president does not respect the constitution is not a country that deserves my love.</p>
                        <p>I wrote this song as a plea to the American people to stay engaged, stay awake, and stay involved in shaping the future of our country. It was inspired by the heartbreaking brutality inflicted by ICE, and it reflects my belief that we can (and must) demand better from the systems and leaders that govern us. But nothing will change if we don’t raise our voices and take a stand.</p>
                        <p>I plan to vote YES in Virginia’s special election before April 21, 2026 through early voting.</p>
                        <p>This is the start of a new period of music for me. I always use music as a form of therapy. A few years ago, I was making music to help me get through the personal tragedy of losing my father to pancreatic cancer. Now I am making music to help me get me through a tragedy we’re collectively living through on a daily basis.”</p>
                    </blockquote>
                    <p>John Levengood is a recording artist, songwriter, music producer, and engineer residing in metropolitan Washington, DC. He is a grassroots queer icon with a vision, a popstar with a purpose. His catchy hooks, witty lyrics, and elaborate live performances with backup dancers are a tribute to all things queer. He wants his music to empower others to be themselves, embrace their identity and most importantly to use their voice to make an impact.</p>
                    <p>In the past few years, John achieved viral fame within the LGBTQ+ community. On Instagram alone, he racked up over 5 million views and reached more than 1.5 million accounts since June 2024. His rise to icon status was sealed when he became a meme. </p>
                    <p>In 2025, John began producing a documentary in partnership with Second World Entertainment which documents his performances at pride festivals all over the country while comparing the impacts of pride festivals in big cities compared to small towns.</p>
                    <p>John is one of the resident hosts and emcee of karaoke at Freddie’s Beach Bar, Northern Virginia’s one and only gay bar. This is where his journey to stardom took flight. Here, he learned from the dazzling drag queens like Destiny B. Childs, Monet Dupree, and Sasha Adams Sanchez as their DJ. In 2022, John rocked the stage at Capital Pride in the Nation's Capital, performing his anthem "Say Gay!" for the first time live. This was only his second time attending a pride festival. Since then, he has wowed audiences at nearly 40 pride festivals across the country, from Newark Pride at the New Jersey Performing Arts Center to the main stage at Charlotte Pride in North Carolina, and all the way to Little Rock, Arkansas and Kenosha, Wisconsin. John also performed on the main stage at World Pride in Washington, DC in 2025. He is on his way to becoming a global queer sensation.</p>
                    <p>More info can be found at <a href='https://www.johnlevengood.com/about' noreferrer target='_blank'>https://www.johnlevengood.com/about</a></p>
                    <blockquote style={{paddingLeft:'30px'}}>
                        <h4>Lyrics of "Make Me Proud, America"</h4>
                        <p>Little boy hand cuffed<br></br>
                        Mom and dad tied up<br></br>
                        In the back of an unmarked truck<br></br><br></br>
                        Citizens gunned down<br></br>
                        Reasoning not found<br></br>
                        A copper scent fills the air in town<br></br>
                        <br></br>
                        We are constitutionally (yeah)<br></br>
                        Entitled to protest tyranny (yeah)<br></br>
                        Without military or police (no no no)<br></br>
                        Impeding due process or our peace<br></br>
                        <br></br>
                        Will we stand up and do something about it?<br></br>
                        Or will we just watch and sit on our hands?<br></br>
                        Why aren't you up on your feet angry and shouting?<br></br>
                        Is this how democracy is to end?<br></br>
                        I pray to God that America will make me proud<br></br>
                        <br></br>
                        Civil war on deck<br></br>
                        President unchecked<br></br>
                        While the rich fill up their pockets<br></br>
                        People tired of lies<br></br>
                        Every day less rights<br></br>
                        It's getting harder to see the light<br></br>
                        <br></br>
                        Right here in the land of the free<br></br>
                        There's crisis of our humanity<br></br>
                        We've got a choice to make carefully<br></br>
                        Between oppression or liberty<br></br>
                        <br></br>
                        Will we stand up and do something about it?<br></br>
                        Or will we just watch and sit on our hands?<br></br>
                        Why aren't you up on your feet angry and shouting?<br></br>
                        Is this how democracy is to end?<br></br>
                        I pray to God that America will make me proud<br></br>
                        <br></br>
                        Make me proud, America<br></br>
                        Make me proud, America<br></br>
                        Make me proud, America<br></br>
                        Make me proud, America<br></br>
                        <br></br>
                        It's time to stand up and do something about it!<br></br>
                        We cannot just watch and sit on our hands!<br></br>
                        It's time to get on your feet angry and shouting!<br></br>
                        We won't let democracy come to end!<br></br>
                        <br></br>
                        I pray to God that America will make me proud</p>
                        
                    </blockquote>
                
                </Col>
            </Row>
        </Container>
    <Footer />
    </>
    
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps
    }
}

export default connect(mapStateToProps)(PressReleaseMakeMeProud)